import { darken, lighten } from '../../../../../helpers';
/**
 *  Constants
 */
export const darkenValue = 10;
export const lightenValue = 10;
/**
 *  Colors
 */
const brandPrimary = '#E90066';
const brandPrimaryDark = '#D9005C';
const brandPrimaryLight = '#F13D89';
const brandPrimaryUltraLight = '#FFEBFF';
const brandSecondary = '#0A26EE';
const brandSecondaryDark = '#000AB8';
const brandSecondaryLight = '#3D47F5';
const brandSecondaryUltraLight = '#EDF1F7';
const brandTertiary = '#00DCD4';
const brandTertiaryLight = '#3DE5DF';
const brandTertiaryUltraLight = '#D4F9F8';
const brandTertiaryDark = '#00CBC4';
const extra = '#7000C8';
const extraLight = '#8E3DF5';
const extraUltraLight = '#f7f1ff';
const extraDark = '#6700B8';
const greyScale100 = '#000018';
const greyScale84 = '#29293D';
const greyScale72 = '#474759';
const greyScale60 = '#666474';
const greyScale48 = '#858590';
const greyScale36 = '#A3A3AC';
const greyScale24 = '#C2C2C8';
const greyScale16 = '#D6D6DA';
const greyScale8 = '#EBEBED';
const greyScale4 = '#F5F5F6';
const greyScale0 = '#FFFFFF';
const brandHiring = '#24BB72';
const brandHiringDark = '#13B165';
const brandHiringUltraLight = '#A7E4C7';
const brandHiringBlack = '#3B3F51';
const brandHiringLight = '#33CC82';
const link = `#000DF1`;
const success = `#51CF66`;
const warning = `#FAB005`;
const danger = `#C92A2A`;
const info = `#259DD5`;
const simple = `#808080`;
const brandAlternativeAlert = '#FAB306';
const brandAlternativeError = '#EC0000';
/**
 * Background color for `<body>`.
 */
const bodyBg = brandSecondaryUltraLight;
/**
 * Global text color on `<body>`.
 */
const textColor = `#212121`;
/**
 * Background color for `<html>`.
 */
const htmlBg = `transparent`;
/**
 * Colores de destaque de productos y bordes
 */
const avisoHome = '#FAB306';
/**
 * Colores de destaque de productos infinit
 */
const avisoInfinitPrimary = '#8E3DF5';
/**
 * Colores de destaque de productos zonajobs
 */
const avisoZonajobs = '#FE633F';
const colors = {
    primary: {
        normal: brandPrimary,
        lighten: brandPrimaryLight,
        darken: brandPrimaryDark,
        ultraLighten: brandPrimaryUltraLight,
    },
    secondary: {
        normal: brandSecondary,
        lighten: brandSecondaryLight,
        darken: brandSecondaryDark,
        ultraLighten: brandSecondaryUltraLight,
    },
    tertiary: {
        normal: brandTertiary,
        lighten: brandTertiaryLight,
        darken: brandTertiaryDark,
        ultraLighten: brandTertiaryUltraLight,
    },
    extra: {
        normal: extra,
        lighten: extraLight,
        darken: extraDark,
        ultraLighten: extraUltraLight,
    },
    hiring: {
        normal: brandHiring,
        lighten: brandHiringLight,
        darken: brandHiringDark,
        ultraLighten: brandHiringUltraLight,
        black: brandHiringBlack,
    },
    alternativeError: brandAlternativeError,
    alternativeAlert: brandAlternativeAlert,
    grey100: greyScale100,
    grey84: greyScale84,
    grey72: greyScale72,
    grey60: greyScale60,
    grey48: greyScale48,
    grey36: greyScale36,
    grey24: greyScale24,
    grey16: greyScale16,
    grey8: greyScale8,
    grey4: greyScale4,
    grey0: greyScale0,
    info: {
        normal: info,
        darken: darken(info, darkenValue),
        lighten: lighten(info, lightenValue),
    },
    success: {
        normal: success,
        darken: darken(success, darkenValue),
        lighten: lighten(success, lightenValue),
    },
    simple: {
        normal: simple,
        darken: darken(simple, darkenValue),
        lighten: lighten(simple, lightenValue),
    },
    warning: {
        normal: warning,
        darken: darken(warning, darkenValue),
        lighten: lighten(warning, lightenValue),
    },
    danger: {
        normal: danger,
        darken: darken(danger, darkenValue),
        lighten: lighten(danger, lightenValue),
    },
    link: {
        normal: link,
        darken: darken(link, darkenValue),
        lighten: lighten(link, lightenValue),
    },
    aviso: {
        infinit: {
            brandPrimary: avisoInfinitPrimary,
        },
        border: {
            freemium: brandPrimary,
            talento: brandPrimary,
            simple: brandPrimary,
            destacado: brandPrimary,
            home: brandAlternativeAlert,
            tecnologia: brandSecondary,
            zonajobs: avisoZonajobs,
            infinit: avisoInfinitPrimary,
        },
        destaque: {
            tecnologia: brandSecondary,
            destacado: brandPrimary,
            home: avisoHome,
            zonajobs: avisoZonajobs,
        },
    },
    'body-bg': bodyBg,
    'html-bg': htmlBg,
    'text-color': textColor,
    'link-color': brandSecondary,
};
export default colors;
